import type { FC } from 'react';

import * as styles from './reward-badges.css.ts';

interface RewardItem {
  readonly amount: number;
  readonly imageUrl: string | null;
}

interface RewardBadgesProps {
  readonly rewardPoints?: RewardItem[];
  readonly loyaltyPoints?: RewardItem[];
}

export const RewardBadges: FC<RewardBadgesProps> = ({
  rewardPoints,
  loyaltyPoints,
}) => {
  if (!rewardPoints?.length && !loyaltyPoints?.length) return null;

  return (
    <div className={styles.container}>
      {rewardPoints?.map((reward, index) => (
        <div key={index} className={`${styles.badge} ${styles.rewardBadge}`}>
          <img
            src={reward.imageUrl ?? ''}
            alt='Reward Points'
            className={styles.icon}
          />
          <span className={`${styles.value} ${styles.rewardValue}`}>
            {reward.amount}
          </span>
        </div>
      ))}
      {loyaltyPoints?.map((reward, index) => (
        <div key={index} className={`${styles.badge} ${styles.loyaltyBadge}`}>
          <img
            src={reward.imageUrl ?? ''}
            alt='Loyalty'
            className={styles.icon}
          />
          <span className={`${styles.value} ${styles.loyaltyValue}`}>
            {reward.amount}
          </span>
        </div>
      ))}
    </div>
  );
};
